<template>
  <transition
    enter-active-class="tw-transform tw-ease-out tw-duration-300 tw-transition"
    enter-from-class="tw-translate-y-2 tw-opacity-0 sm:tw-translate-y-0 sm:tw-translate-x-2"
    enter-to-class="tw-translate-y-0 tw-opacity-100 sm:tw-translate-x-0"
    leave-active-class="tw-transition tw-ease-in tw-duration-100"
    leave-from-class="tw-opacity-100"
    leave-to-class="tw-opacity-0"
  >
    <div v-if="show" @click="handleOpen()" class="tw-cursor-pointer tw-fixed tw-top-4 tw-right-4 tw-z-[9999] tw-max-w-sm tw-w-full tw-bg-white dark:tw-bg-gray-800 tw-shadow-xl tw-rounded-lg tw-pointer-events-auto tw-border tw-border-gray-100 dark:tw-border-gray-700 tw-overflow-hidden">
      <div class="tw-p-4">
        <div class="tw-flex tw-items-start">
          <div class="tw-flex-shrink-0">
            <!-- Bell Icon -->
            <svg class="tw-h-6 tw-w-6 tw-text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          <div class="tw-ml-3 tw-w-0 tw-flex-1 tw-pt-0.5">
            <p class="tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-white">{{ title }}</p>
            <p class="tw-mt-1 tw-text-sm tw-text-gray-500 dark:tw-text-gray-300">{{ message }}</p>
          </div>
          <div class="tw-ml-4 tw-flex-shrink-0 tw-flex">
            <div @click.stop="close" class="tw-bg-transparent tw-cursor-pointer tw-rounded-md tw-inline-flex tw-text-gray-400 hover:tw-text-gray-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500">
              <span class="tw-sr-only">Chiudi</span>
              <svg class="tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <!-- Progress bar (optional visual touch) -->
      <div v-if="show" class="tw-h-1 tw-bg-blue-500 tw-transition-all tw-duration-[4000ms] tw-ease-linear tw-w-0 tw-animate-progress"></div>
    </div>
  </transition>
</template>

<script>
import { promoPayments } from "@/helpers/utilities";
import { routesEnums } from "@/helpers/enums";
import { mapActions } from 'vuex'
import { MODULES } from "@/store/modules-enum";
import { NOTIFICATIONS_ACTIONS } from "@/store/notifications/actions-enum";

export default {
  name: 'NotificationToast',
  data() {
    return {
      show: false,
      title: '',
      message: '',
      actionType: null,
      notificationData: null,
      timer: null
    }
  },
  methods: {
    ...mapActions(MODULES.NOTIFICATIONS, [NOTIFICATIONS_ACTIONS.REMOVE_NOTIFICATIONS_BY_TYPE]),
    display(payload, duration = 5000) {
      
      this.title = payload.title;
      this.message = payload.body || payload.message;
      this.actionType = payload.type;
      this.notificationData = payload.data || {};
      this.show = true;
      
      if (this.timer) clearTimeout(this.timer);
      
      this.timer = setTimeout(() => {
        this.close();
      }, duration);
    },
    close() {
      this.show = false;
      if (this.timer) clearTimeout(this.timer);
    },
    handleOpen(){
      const type = String(this.actionType || this.notificationData?.type || '');
      const url = this.notificationData?.url || null;
      
      if(type && !url){
          switch (type) {
              case '3':
                  this.$router.push('/bandi-in-scadenza').catch(err => {
                      if (err.name !== 'NavigationDuplicated') throw err;
                  });
                  break;
              case '2':
                  const act = this.notificationData?.act;
                  if (act) {
                      this.$router.push({ 
                          name: routesEnums.PROFILE, 
                          params: { promoCode: act } 
                      }).catch(err => {
                          if (err.name !== 'NavigationDuplicated') throw err;
                      });
                      this.$root.$emit('promo-activated', act);
                  }
                  break;
              default:
                  break;
          }
      } else if(url){
          window.open(url, '_blank', 'noopener');
      }
      this.close();
    }
  }
}
</script>

<style scoped>
/* Simple keyframe for the progress bar if not using a complex JS animation */
@keyframes progress {
  from { width: 100%; }
  to { width: 0%; }
}
.tw-animate-progress {
  animation: progress 4s linear forwards;
}
</style>